import { Component, Injector, OnInit } from '@angular/core';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { map } from 'rxjs';
import { BaseBulkType } from '../../common/abstract/BaseBulkType';
import { FormlyFieldProps } from '@ngx-formly/core';

@Component({
  selector: 'formly-bulk-radio-type',
  templateUrl: './bulk-radio-type.component.html',
  styleUrls: ['./bulk-radio-type.component.scss'],
})
export class BulkRadioTypeComponent extends BaseBulkType implements OnInit {
  datasource: any;
  override hide: boolean = false;
  override get props(): FormlyFieldProps & { [additionalProperties: string]: any; } {
    return super.props;
  }
  
  constructor(private injector: Injector) {
    super();
  }

  ngOnInit() {
    this.hide = this.props.hidden || this.hide;
    this.datasource = this.injector.get(LookupGetService).loadCachedOptions(this.props["lookupname"]).
      pipe(
        map(res => Array.isArray(res) ? res : Object.values(res || {}))
      );
    this.expandCheckbox();
  }

  select(value: any) {
    if (this.props?.disabled) return;
    this.formControl?.setValue(value);
    this.formControl?.markAsTouched();
    this.formControl?.markAsDirty();
    this.updateCheckbox();
  }

  getValue(o: any) {
    const vp = this.props["valueProp"] || 'id';
    return o?.[vp] ?? o?.value ?? o;
  }

}

